import Controller from "csi/action/Controller";
import def from "csi/def";
import locale from "csi/locale";
import { FormStore, NewFormDialog } from "csi/middleware/form/index";
import reflection from "csi/reflection";
import { shouldUseReactForm } from "csi/service/viewService";
import { routerStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";
import { getFormStateByNodeType, IGetForm } from "src/c8-platform/service/formService";
import { cnl } from "src/c8-platform/type/value";

const EditController = declare(Controller, {
	constructor: function(/*Object*/params) {
		var node = this.m_cache.getNode(this.m_urlNode, true);
		
		// if on revision class and editing using default form, then switch to master;
		// this is added to handle create form definitions on revisable classes
		var idForm = this.m_action.m_viewRef ? this.m_action.m_viewRef.m_id : null;
		
		if (node && reflection.getNodeClass(node).isRevision() && (idForm == def.DEFAULT_FORM_ID)) {
			this.m_urlNode = node.Master;
			node = this.m_cache.getNode(this.m_urlNode, true);
		}
		
		this.m_typeName = locale.getNodeTypeName(node) || locale.resource("TYPE_DEFAULT");
	},

	getStringParameters: function() {
		return [this.m_typeName];
	},

	/** Not needed for the new react form */
	toWriter: function() {
		var call = this.inherited(arguments);
		
		// write out fields from form (if any)
		this.toWriterFields(this.m_urlNode);
		
		// call the validation method on the server
		if (this.m_writer.isChanged()) {
			this.validateNode(this.m_urlNode, true);
		}
		
		return call;
	},
		
	/**
	 * @override
	 * call mixin before continuing
	 */
	preProcess() {
		const node = this.m_cache.getNode(this.m_urlNode, true);
		this.useReactForm = shouldUseReactForm(node.$Type);
		if (this.useReactForm) {
			this.preProcessReactForm();
			return;
		}
		this.inherited(arguments);
	},
		
	/** preProcess for the new React form */
	preProcessReactForm() {
		this.suspendProcess();
		const { m_urlNode } = this;
		const node = this.m_cache.getNode(m_urlNode, true);

		const form: IGetForm = {
			nodeType: node.$Type,
			nodeUrl: m_urlNode,
			sourceNodeUrl: m_urlNode,
		};
		
		const formInfo = getFormStateByNodeType(form);
		
		const processFormCallback = (formNodeCNL: cnl, bNavigate: boolean, bRepeat: boolean): void => {
			this.m_urlNode = formNodeCNL;
			this.resumeProcess();
			this.postProcess(true);
		};
		
		const processCancelFormCallback = (): void => {
			this.repeatReactForm = false;
			this.onCancelReactDialog();
		};
		
		formInfo.then((formInfo) => {
			const cache = this.getCache();
			const store = new FormStore(
				cache,
				formInfo,
				processFormCallback,
				processCancelFormCallback,
				false,
				false,
			);
		
			this.useReactDialog(routerStore.openDialog(NewFormDialog, { store, title: this.getTitle() }));
		});
	},
		
	postProcessSuccess: function() {
		// summary: refresh display of node unless configured PostAction returns deferred object in which
		// case that should do all refreshing
		var dfd = this.inherited(arguments);
		return dfd || this.widget.redrawNode(this.refNode || this.m_element);
	},
		
	/** Not needed for the new react form */
	/**
	 * @override
	 * Specify form info
	 */
	_onCreatePopupParams(viewParams) {
		const node = this.getNode();
		const parentUrl = node.__Parent__;
		
		viewParams.formInfo = {
			nodeUrl: node.$URL,
			nodeType: node.$Type,
			parentUrl,
			sourceNodeUrl: node.$URL,
		};
		
		this.inherited(arguments);
	},
});

export = EditController;